import styleService from '@nykaa/deals-utils/styles';
import styled from '@emotion/styled';
const { getMarginStyles, getPaddingStyles, } = styleService.utils;
const linearGradient = (colorStart, colorEnd) => `linear-gradient(to left, ${colorStart} 50%, ${colorEnd} 50%)`;
export const CarouselWrapper = styled.div `
   ${({ wrapperSpacing, isDesktop }) => (isDesktop ? '' : getPaddingStyles(wrapperSpacing.padding))};
   padding-top:0;
    overflow: hidden;
    .swtitleWrapper{
      display:flex;
    }
    .edgetoedge
    {
      margin-left:-${({ wrapperSpacing, isDesktop }) => { var _a, _b; return (isDesktop ? '' : ((_b = (_a = wrapperSpacing === null || wrapperSpacing === void 0 ? void 0 : wrapperSpacing.padding) === null || _a === void 0 ? void 0 : _a.left) === null || _b === void 0 ? void 0 : _b.web)); }};
      margin-right:-${({ wrapperSpacing, isDesktop }) => { var _a, _b; return (isDesktop ? '' : ((_b = (_a = wrapperSpacing === null || wrapperSpacing === void 0 ? void 0 : wrapperSpacing.padding) === null || _a === void 0 ? void 0 : _a.right) === null || _b === void 0 ? void 0 : _b.web)); }};
    }
    background:  ${(props) => props.bkgColor};
    @media only screen  and (min-width : 768px) {
    
        .edgetoedge {
            padding-left: 0px;
            padding-right: 0px;
        }
        
        .snaptogrid {
            padding-left: 48px;
            padding-right: 48px;
        }
    }
  
    @media only screen  and (min-width : 1600px) {
      margin-left: auto;
      margin-right: auto;
      max-width: 1600px;
      .snaptogrid {
        padding-left: 0px;
        padding-right: 5px;
    }
    }
`;
export const SlidesContainer = styled.div `
  height: 100%;
  width: 100%;
  display: flex;
  overflow: hidden;
  position: relative;
  padding-top:${({ swPadding }) => { var _a; return (_a = swPadding === null || swPadding === void 0 ? void 0 : swPadding.top) === null || _a === void 0 ? void 0 : _a.web; }};
`;
export const SnaptogridContainer = styled.div `
  height: 100%;
  width: 100%;
  display: flex;
  flex: 1 0 100%;
  flex-basis: 84%;
  position: relative;
  padding-top:${({ swPadding }) => { var _a; return (_a = swPadding === null || swPadding === void 0 ? void 0 : swPadding.top) === null || _a === void 0 ? void 0 : _a.web; }};
  padding-bottom:${({ isDesktop, swPadding }) => { var _a, _b; return (_b = (isDesktop ? (_a = swPadding === null || swPadding === void 0 ? void 0 : swPadding.bottom) === null || _a === void 0 ? void 0 : _a.web : '0px')) !== null && _b !== void 0 ? _b : '0px'; }};
`;
export const SlideWrapper = styled.div `
  align-items: center;
  flex: 0 0 auto;
  width: 100%;
  text-align: center;
  .banner-container
  {
    padding-bottom: 0;
  }
`;
export const SlideSanptogridWrapper = styled.div `
  align-items: center;
  flex: 0 0 auto;
  width: ${({ isDesktop }) => (isDesktop ? '100%' : '100%')};
  text-align: center;
  display: ${({ isDesktop }) => (isDesktop ? 'inline-block' : '')};
  margin: 0px ${({ interItem, isDesktop }) => (isDesktop ? interItem.web : interItem.web)} 0px 0px;
  :last-child{
  margin-right:0;
  }
  .banner-container
  {
    padding-bottom: 0;
  }
`;
export const IndicatorPosition = styled.span `
  color: ${({ positionIndicator, isNewTemplate }) => { var _a, _b, _c, _d; return (isNewTemplate ? (_b = (_a = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.snapToGridIndicator) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.color : (_d = (_c = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.indicator) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.color); }};
  color: #${({ positionIndicator, isNewTemplate }) => { var _a, _b, _c, _d; return (isNewTemplate ? (_b = (_a = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.snapToGridIndicator) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.color : (_d = (_c = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.indicator) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.color); }};
  font-size: ${({ positionIndicator, isNewTemplate }) => { var _a, _b, _c, _d, _e, _f; return (isNewTemplate ? (_c = (_b = (_a = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.snapToGridIndicator) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.size) === null || _c === void 0 ? void 0 : _c.web : (_f = (_e = (_d = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.indicator) === null || _d === void 0 ? void 0 : _d.text) === null || _e === void 0 ? void 0 : _e.size) === null || _f === void 0 ? void 0 : _f.web); }};
  flex:none;
  font-family: ${({ positionIndicator, isNewTemplate }) => { var _a, _b, _c, _d; return (isNewTemplate ? (_b = (_a = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.snapToGridIndicator) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.fontFamily : (_d = (_c = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.indicator) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.fontFamily); }};
  font-weight: ${({ positionIndicator, isNewTemplate }) => { var _a, _b, _c, _d; return (isNewTemplate ? (_b = (_a = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.snapToGridIndicator) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.fontWeight : (_d = (_c = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.indicator) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.fontWeight); }};
  line-height: ${({ positionIndicator, isNewTemplate }) => { var _a, _b, _c, _d; return (isNewTemplate ? (_b = (_a = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.snapToGridIndicator) === null || _a === void 0 ? void 0 : _a.text) === null || _b === void 0 ? void 0 : _b.size.web : (_d = (_c = positionIndicator === null || positionIndicator === void 0 ? void 0 : positionIndicator.indicator) === null || _c === void 0 ? void 0 : _c.text) === null || _d === void 0 ? void 0 : _d.size.web); }};
  text-align: end;
  align-self: flex-end;
  ${({ titleCss }) => getMarginStyles(titleCss.margin)};
`;
export const Buttons = styled.button `
  display: block;
  width: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b, _c, _d, _e, _f; return (isNewTemplate ? (_c = (_b = (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.edgeToEdgeIndicator) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.width) === null || _c === void 0 ? void 0 : _c.web : (_f = (_e = (_d = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicator) === null || _d === void 0 ? void 0 : _d.size) === null || _e === void 0 ? void 0 : _e.width) === null || _f === void 0 ? void 0 : _f.web); }};
  height: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b, _c, _d, _e, _f; return (isNewTemplate ? (_c = (_b = (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.edgeToEdgeIndicator) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.width) === null || _c === void 0 ? void 0 : _c.web : (_f = (_e = (_d = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicator) === null || _d === void 0 ? void 0 : _d.size) === null || _e === void 0 ? void 0 : _e.width) === null || _f === void 0 ? void 0 : _f.web); }};
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  border-radius:100%;
  background: #${({ positionindicatorCss, isNewTemplate }) => { var _a, _b; return (isNewTemplate ? (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _a === void 0 ? void 0 : _a.baseColour : (_b = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _b === void 0 ? void 0 : _b.colorStart); }};
  background: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b; return (isNewTemplate ? (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _a === void 0 ? void 0 : _a.baseColour : (_b = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _b === void 0 ? void 0 : _b.colorStart); }};
  
`;
export const Bar = styled.ul `
  list-style: none;
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
  line-height:0;
  ${({ positionindicatorCss }) => getPaddingStyles(positionindicatorCss.padding)};
`;
export const Wrapper = styled.li `
  position: relative;
  display: inline-block;
  margin: 0 3px;
  &.active {
    button {
    background: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b, _c, _d; return (isNewTemplate ? linearGradient((_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _a === void 0 ? void 0 : _a.baseColour, (_b = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _b === void 0 ? void 0 : _b.highlightColour) : linearGradient((_c = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _c === void 0 ? void 0 : _c.colorStart, (_d = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _d === void 0 ? void 0 : _d.colorEnd)); }};
    background-size: 200% 100%;
    background-position:left bottom;
    background-position: 0px 100%;
    }
  }
`;
export const ProgressiveButtons = styled.button `
  font-size: 0;
  line-height: 0;
  display: block;
  width: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b, _c, _d, _e, _f; return (isNewTemplate ? (_c = (_b = (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.edgeToEdgeIndicator) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.width) === null || _c === void 0 ? void 0 : _c.web : (_f = (_e = (_d = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicator) === null || _d === void 0 ? void 0 : _d.size) === null || _e === void 0 ? void 0 : _e.width) === null || _f === void 0 ? void 0 : _f.web); }};
  height: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b, _c, _d, _e, _f; return (isNewTemplate ? (_c = (_b = (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.edgeToEdgeIndicator) === null || _a === void 0 ? void 0 : _a.size) === null || _b === void 0 ? void 0 : _b.height) === null || _c === void 0 ? void 0 : _c.web : (_f = (_e = (_d = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicator) === null || _d === void 0 ? void 0 : _d.size) === null || _e === void 0 ? void 0 : _e.height) === null || _f === void 0 ? void 0 : _f.web); }};
  cursor: pointer;
  color: transparent;
  border: 0;
  outline: none;
  border-radius: 3px;
  background: #${({ positionindicatorCss, isNewTemplate }) => { var _a, _b; return (isNewTemplate ? (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _a === void 0 ? void 0 : _a.baseColour : (_b = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _b === void 0 ? void 0 : _b.colorStart); }};
  background: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b; return (isNewTemplate ? (_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _a === void 0 ? void 0 : _a.baseColour : (_b = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _b === void 0 ? void 0 : _b.colorStart); }};
    
`;
export const BarProgressive = styled.ul `
  list-style: none;
  text-align: center;
  width: 100%;
  padding: 0;
  margin: 0;
  line-height:0;
  ${({ positionindicatorCss }) => getPaddingStyles(positionindicatorCss.padding)};
`;
export const WrapperProgressive = styled.li `
  position: relative;
  display: inline-block;
  margin: 0 3px;
  button{
    background-position:right bottom;
    transition: background-position 0ms ease-out;
  }
  &.active {
    button {
    background: ${({ positionindicatorCss, isNewTemplate }) => { var _a, _b, _c, _d; return (isNewTemplate ? linearGradient((_a = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _a === void 0 ? void 0 : _a.baseColour, (_b = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.indicatorBkg) === null || _b === void 0 ? void 0 : _b.highlightColour) : linearGradient((_c = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _c === void 0 ? void 0 : _c.colorStart, (_d = positionindicatorCss === null || positionindicatorCss === void 0 ? void 0 : positionindicatorCss.bkg) === null || _d === void 0 ? void 0 : _d.colorEnd)); }};
    background-size: 200% 100%;
    background-position:left bottom;
    background-position: 0px 100%;
      transition: background-position ${({ delayTime }) => delayTime}ms ease-in;
    }
  }
`;
export const LeftArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/3df01759-af0c-4d81-b2f7-f61577ac3807.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  left: 8px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
export const RightArrow = styled.div `
  background: url("https://images-static.nykaa.com/uploads/45d5a7b6-86eb-4850-9568-4d6ed91731fe.svg");
  background-repeat: no-repeat;
  transform: initial;
  height: 56px;
  width: 56px;
  top: 45%;
  content: "";
  display: inline-block;
  position: absolute;
  right: 6px;
  border: 0;
  cursor: pointer;
  z-index: 2;
`;
export const CarouselDesktopbgWrapper = styled.div `
${({ isDesktop, bkgColor }) => (isDesktop && `
    background:  ${bkgColor};
      `)};
`;
